import React from 'react';

///Styles
import {FaSearch} from 'react-icons/fa';
import {Container} from './styles';

export function Input({input,setInput,action,radioButtons,filter,setFilter}){
    return(
        <Container onSubmit={action}>
            <div className="radios-container">
               {
                   radioButtons.map((item) => {
                       return (
                        <div className="radio" key={item.id}>
                            <input
                                type={'radio'}
                                value={item.value}
                                checked={filter === item.value}
                                onChange={(event) => setFilter(event.target.value)}
                            />

                            <label>
                                {item.label}
                            </label>
                        </div>
                       )
                   })
               }
            </div>

            <div className="inputs-container">
                <input
                    placeholder='Buscar Empresa'
                    value={input}
                    onChange={setInput}
                />

                <button type='submit'>
                    <FaSearch/>
                </button>
            </div>
        </Container>
    )
}